"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

require("tiny-slider/src/tiny-slider.scss");

var _excluded = ["settings", "children", "Controls"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getPosition = function getPosition(loop, info) {
  var hasMoreItems = info.slideCount > info.items;
  var isFirst = false;
  var isLast = false;

  if (!hasMoreItems) {
    isFirst = true;
    isLast = true;
  } else if (!loop) {
    if (info.index === 0) {
      isFirst = true;
    } else if (info.index + info.items === info.slideCount) {
      isLast = true;
    }
  }

  return {
    isFirst: isFirst,
    isLast: isLast
  };
};

var Slider = /*#__PURE__*/(0, _react.forwardRef)(function Slider(_ref, ref) {
  var _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? {} : _ref$settings,
      children = _ref.children,
      Controls = _ref.Controls,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var Component = 'div';
  var sliderRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      controlsProps = _useState2[0],
      setControlsProps = _useState2[1];

  (0, _react.useImperativeHandle)(ref, function () {
    var _sliderRef$current;

    return (sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current = sliderRef.current) === null || _sliderRef$current === void 0 ? void 0 : _sliderRef$current.slider) || {};
  }, [sliderRef]);
  (0, _react.useEffect)(function () {
    var _sliderRef$current2;

    if (!(sliderRef !== null && sliderRef !== void 0 && (_sliderRef$current2 = sliderRef.current) !== null && _sliderRef$current2 !== void 0 && _sliderRef$current2.slider) || !Controls) {
      return;
    }

    var isLoop = settings.loop === false ? false : true;
    var info = sliderRef.current.slider.getInfo();
    var controlPropsBase = {
      onClickPrev: function onClickPrev() {
        sliderRef.current.slider.goTo('prev');
      },
      onClickNext: function onClickNext() {
        sliderRef.current.slider.goTo('next');
      }
    };
    setControlsProps(_objectSpread(_objectSpread({}, controlPropsBase), getPosition(isLoop, info)));

    var onIndexChanged = function onIndexChanged(newInfo) {
      setControlsProps(_objectSpread(_objectSpread({}, controlPropsBase), getPosition(isLoop, newInfo)));
    };

    sliderRef.current.slider.events.on('indexChanged', onIndexChanged);
    return function () {
      var _sliderRef$current3;

      if (sliderRef !== null && sliderRef !== void 0 && (_sliderRef$current3 = sliderRef.current) !== null && _sliderRef$current3 !== void 0 && _sliderRef$current3.slider) {
        sliderRef.current.slider.events.off('indexChanged', onIndexChanged);
      }
    };
  }, [sliderRef, setControlsProps, settings, Controls]);

  if (typeof window !== 'undefined') {
    Component = require('tiny-slider-react')["default"];
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Component, _extends({
      settings: settings,
      ref: sliderRef
    }, otherProps), children), !!controlsProps && /*#__PURE__*/_react["default"].createElement(Controls, controlsProps));
  }

  return /*#__PURE__*/_react["default"].createElement(Component, null, children);
});
var _default = Slider;
exports["default"] = _default;